/**
 * @desc: - 弹出框 (普通弹出框)
 * @param  {[STRING]} className： [顶层class]
 * @param  {[STRING]} title：     [顶部文字]
 * @param  {[STRING]} text：      [显示内容]
 * @param  {[STRING]} buttonText: [按钮显示文字]
 * @param  {[FUNCTION]} callback: [点击confirm之后的回调函数]
 * @param  {[bool]} display: [是否显示弹出框]
 * @param  {[NUMBER]} delay: [倒数几秒后自动点击confirm]
 * @author: circle
 * @example:<ALERT display = {this.state.display} callback={this.hide.bind(this)} text="内容" delay="5" />
 */
import React from 'react';
import ReactDOM from 'react-dom'

export default class ALERT extends React.Component {
  constructor(props) {
    super(props);
    this.handleEnterPress = this.handleEnterPress.bind(this);
    this.makeButtonText = this.makeButtonText.bind(this);
  }
  
  shouldComponentUpdate(nextProps){
    if (nextProps.text == this.props.text) {
      return false;
    }
    return true;
  }

  componentDidUpdate(){
    let modalTop = (window.screen.height/2 - this.refs.alertModal.offsetHeight) + 'px';
    this.refs.alertModal.style.top = modalTop;
    this.makeButtonText();
  }

  handleEnterPress(func){
    const { params } = this.props;
    if (this.delayTimer) {
      window.clearInterval(this.delayTimer);
    }
    this.delay = null;
    ReactDOM.findDOMNode( this.refs.closeBtn ).value = 'confirm';
    func(params);
  }

  // 生成按钮文字
  makeButtonText(){  

    let { display, buttonText, delay, callback } = this.props;

    if (display && delay && !this.delay) {
      if (this.delayTimer) {
        window.clearInterval(this.delayTimer);
      }
      this.delay = delay;
      ReactDOM.findDOMNode( this.refs.closeBtn ).value= buttonText ? buttonText + "（"+this.delay+"）" : "（" +this.delay+ "）confirm";
      this.delay --;
      this.delayTimer = window.setInterval(function(){

        ReactDOM.findDOMNode( this.refs.closeBtn ).value= buttonText ? buttonText + "（"+this.delay+"）" : "（" +this.delay+ "）confirm"
        
        this.delay --;
        if (this.delay === -1) {
          this.handleEnterPress(callback);
        }

      }.bind(this),1000)

    }else{
      ReactDOM.findDOMNode( this.refs.closeBtn ).value= buttonText || 'confirm';
    }

  }

  render() {

    let { className, title, text, buttonText, display, delay } = this.props;

    className = className || 'modal-original';
    title = title || 'prompt';
    const style = {
      display: display ? 'block' : 'none'
    }

    return (
      <div>
        <div className={className} style={style} ref="alertModal">
          <h3 className="title">{title}</h3>
          <div id="block_content" className="content">
            <div className="detail">
              <div className="floatarea" dangerouslySetInnerHTML = {{__html:text}}></div>
            </div>
          </div>
          <div id="block_bottom" className="bottom">
            <input type="button" value="confirm" ref="closeBtn" className="submit submit-width" onClick={this.handleEnterPress.bind(this, this.props.callback)}/>
          </div>
        </div>
      </div>
    );
  }
}
